import React from 'react';
import { DataGrid, DataGridProps, gridClasses } from '@mui/x-data-grid';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { createStyleSheet } from 'utils/helpers';
import { Stack } from '@mui/material';
const BaseDataGrid: React.FC<DataGridProps> = ({ ...props }) => {
    return (
        <Stack spacing={2}>
            <DataGrid
                {...props}
                sx={{ ...styles.dataGrid, ...props.sx }}
                autoHeight={props.autoHeight}
                checkboxSelection={props.checkboxSelection}
                disableRowSelectionOnClick={props.disableRowSelectionOnClick}
                hideFooterPagination={props.hideFooterPagination}
                hideFooterSelectedRowCount={props.hideFooterSelectedRowCount}
                hideFooter={props.hideFooter}
                rowSelectionModel={props.rowSelectionModel}
                onRowSelectionModelChange={props.onRowSelectionModelChange}
                columns={props.columns}
                rows={props.rows}
                disableColumnMenu={props.disableColumnMenu}
                disableColumnResize={props.disableColumnResize}
                sortingMode="client"
                slots={{
                    columnSortedAscendingIcon() {
                        return <KeyboardArrowUpIcon />;
                    },
                    columnSortedDescendingIcon() {
                        return <KeyboardArrowDownIcon />;
                    },
                    ...props.slots,
                }}
                initialState={{
                    ...props.initialState,
                    pagination: { paginationModel: { pageSize: 10 } },
                }}
                pageSizeOptions={props.pageSizeOptions || [5, 10, 25]}
            />
        </Stack>
    );
};
const styles = createStyleSheet({
    dataGrid: {
        [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
            outline: 'none',
        },
        [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
            {
                outline: 'none',
            },
        '.MuiDataGrid-columnSeparator': {
            display: 'none',
        },
        '.MuiDataGrid-columnHeader': {
            backgroundColor: '#f5f5f5',
        },
        '.MuiDataGrid-columnHeaderTitleContainer': {
            display: 'flex',
            justifyContent: 'space-between',
        },
    },
});
export default BaseDataGrid;
